import styled from "styled-components";

const Underlay = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left:0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 99;
`;

const PopupContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    border-radius: 8px;
    padding: 32px;
    margin: auto;
    width: 100%;
    max-width: 500px;
    max-height: calc(100vh - 20px);
    z-index: 100;
    
    /* @media (max-width: 1000px) {
        max-width: 300px;
    } */
`;

const Xcross = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px 14px;
    cursor: pointer;
`;

const Popup = ({ children, ...props }) => {

    const close = () => {
        if(props.close){
            props.close();
        }
    }

    return (
        <div>
            <Underlay onClick={close}/>
            <PopupContainer {...props} >
                {props.close && <Xcross onClick={close}>✕</Xcross>}
                {children}
            </PopupContainer>
        </div>
    );
}

export default Popup;